import React from 'react';

const WorkExperience = ({
  formData,
  updateFormData,
  handleSave,
  isEditing,
}) => {
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedExperience = formData?.workExperience?.map((exp, i) =>
      i === index ? { ...exp, [name]: value } : exp,
    );
    updateFormData({ workExperience: updatedExperience });
  };

  const addMoreExperience = () => {
    updateFormData({
      workExperience: [
        ...(formData?.workExperience || []),
        {
          company: '',
          position: '',
          duration: '',
          responsibilities: '',
        },
      ],
    });
  };

  const removeExperience = (index) => {
    const newExperience = formData?.workExperience?.filter(
      (_, i) => i !== index,
    );
    updateFormData({ workExperience: newExperience });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Work Experience</h2>
      <p className="text-sm text-gray-500">
        (Optional) Add any relevant work experience
      </p>

      {formData?.workExperience?.map((exp, index) => (
        <div
          key={index}
          className="p-4 border border-gray-200 rounded-lg space-y-4"
        >
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium">Experience #{index + 1}</h3>
            <button
              type="button"
              onClick={() => removeExperience(index)}
              className="text-red-600 hover:text-red-800"
            >
              Remove
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Company Name
              </label>
              <input
                type="text"
                value={exp.company}
                onChange={(e) => handleChange(index, e)}
                name="company"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter company name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Position
              </label>
              <input
                type="text"
                value={exp.position}
                onChange={(e) => handleChange(index, e)}
                name="position"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter position/role"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Duration
              </label>
              <input
                type="text"
                value={exp.duration}
                onChange={(e) => handleChange(index, e)}
                name="duration"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g., Jan 2020 - Dec 2021"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Responsibilities
            </label>
            <textarea
              value={exp.responsibilities}
              onChange={(e) => handleChange(index, e)}
              name="responsibilities"
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe your key responsibilities"
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={addMoreExperience}
        className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Add Work Experience
      </button>

      {isEditing && (
        <div className="flex justify-end mt-4">
          <span onClick={handleSave} className="text-blue-600 cursor-pointer">
            Save
          </span>
        </div>
      )}
    </div>
  );
};

export default WorkExperience;
